// Side-effect module: must stay the first import of `src/main.js`. Module evaluation follows import
// order, so this runs before the router reads the address bar (vue-vxapp#364).
import { capturePasswordLinkFragment } from '@/utils/passwordLinkFragment'

capturePasswordLinkFragment()
